module.exports = __webpack_public_path__ + "static/media/BilalAli.ddb87b27.png";